import React, { useState } from "react";
import QuoteForm from "../../components/press/QuoteForm";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PressService } from "../../services/admin/PressService";
import { useNotification } from "../../context/NotificationContext";

export default function AddQuotePage() {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const [, setIsSubmitting] = useState(false);

    const handlePublish = async (data) => {
        setIsSubmitting(true);
        try {
            const response = await PressService.createQuote(data);
            if (response.status === "success") {
                showNotification({ message: "Quote published successfully", type: "success" });
                navigate("/admin/press");
            } else {
                showNotification({ message: response.message || "Failed to publish quote", type: "error" });
            }
        } catch (error) {
            showNotification({ message: "An error occurred while publishing", type: "error" });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="p-6 lg:p-10 max-w-4xl mx-auto">
                <button
                    onClick={() => navigate("/admin/press")}
                    className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-all text-xs font-bold tracking-widest uppercase mb-6"
                >
                    <ChevronLeft size={16} /> BACK TO PRESS
                </button>

                <div className="mb-10">
                    <h1 className="text-3xl lg:text-4xl font-normal text-black dark:text-white mb-2" style={{ fontFamily: "Playfair Display, serif" }}>
                        Add Featured Quote
                    </h1>
                    <p className="text-black dark:text-white/50 text-sm italic font-serif">
                        Capture a momentous endorsement or a glowing review snippet.
                    </p>
                </div>

                <QuoteForm onSubmit={handlePublish} />
            </div>
    );
}
